import api from './axios';

const domacinstvoService = {
  getAll: (params = {}) => {
    return api.get('/domacinstva', { params });
  },

  getById: (id) => {
    return api.get(`/domacinstva/${id}`);
  },

  create: (data, images = []) => {
    const fd = new FormData();
    fd.append('domacinstvoData', JSON.stringify(data.domacinstvoData));
    fd.append('userData', JSON.stringify(data.userData));
    images.forEach((file) => fd.append('images', file));
    return api.post('/domacinstva', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  update: (id, data) => {
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
    return api.put(
      `/domacinstva/${id}`,
      data,
      isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined,
    );
  },

  delete: (id) => {
    return api.delete(`/domacinstva/${id}`);
  },

  getMoji: () => {
    return api.get('/domacinstva/moja');
  },
};

export default domacinstvoService;
